/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BloodRelationDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: BloodRelationDefinitionDto.source;
    label?: string;
}

export namespace BloodRelationDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
